import {FC} from 'react';
import {IonRouterLink} from '@ionic/react';
import UIStackedInput from '../UICommon/UIStackedInput';
import UIButton from '../UICommon/UIButton';

type LoginPageFormProps = {
  onChange: Function;
  onKeyPress: Function;
  formValues: any;
  formErrorMessages: any;
  login: Function;
}

const LoginPageForm: FC<LoginPageFormProps> = ({
  onChange,
  onKeyPress,
  formValues,
  formErrorMessages,
  login,
}) => {
  return (
    <form className='h-full flex flex-col' onSubmit={(e) => login(e)}>
      <div className='hidden md:block space-y-5'>
        <UIStackedInput
          name='email' text={formValues.email} onChange={onChange} onKeyPress={onKeyPress}
          labelText={'E-postadress'} textStyle='text-navy-blue font-semibold' badInput={formErrorMessages.email}
          inputMode='email'/>
        <UIStackedInput
          name='password' text={formValues.password} onChange={onChange} onKeyPress={onKeyPress} labelText={'Lösenord'}
          textStyle='text-navy-blue font-semibold' type='password' badInput={formErrorMessages.password}/>
      </div>
      <div className='md:hidden space-y-5 pt-2'>
        <UIStackedInput
          name='email' placeholder='E-postadress' text={formValues.email}
          onChange={onChange} onKeyPress={onKeyPress} badInput={formErrorMessages.email}
          style='bg-black-matte text-white caret-white' inputMode='email'/>
        <UIStackedInput
          name='password' placeholder='Lösenord' text={formValues.password}
          onChange={onChange} onKeyPress={onKeyPress} type='password' badInput={formErrorMessages.password}
          style='bg-black-matte text-white caret-white'/>
      </div>
      <div className='flex justify-end items-center'>
        <IonRouterLink
          href='forgot-password'
          className='text-sm font-semibold pt-2 text-red-login'
        >Glömt lösenord</IonRouterLink>
      </div>
      <div className='flex flex-col-reverse md:flex-col mt-auto md:my-auto'>
        <div className='w-full py-3'>
          <UIButton type='full' text='Logga in' style="font-semibold 17 font-Manrope hidden md:block"
            buttonType='submit'/>
          <UIButton type='full' text='Logga in' style="font-semibold 17 font-Manrope round-20 md:hidden"
            buttonType='submit' color='light'/>
        </div>
        {/* <div className='flex items-center justify-center'>
          <div
            className='text-sm font-semibold font-Manrope text-gray-primary md:text-black-ink pr-4'>
          Har du inget konto?
          </div>
          <IonRouterLink
            href="register"
            className='text-sm font-semibold pl-4 text-white md:text-purple-button'
          >Registrera dig</IonRouterLink>
        </div> */}
        {/* COMMENTED FOR NOW */}
      </div>
    </form>
  );
};

export default LoginPageForm;
